import {AnalysisGraphQL, GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {pipelineHasStep} from 'analysis-tool/data/getStepFromAnalysis';

function isAnalysisStepGraphQLInternallyConsistent(
  analysis: AnalysisGraphQL,
  step: GetAnalysisPipelineStep
): boolean {
  return (
    step.definition.incomingEdges.every((edge) => pipelineHasStep(analysis, edge.parent.step.id)) &&
    step.definition.outgoingEdges.every((edge) => pipelineHasStep(analysis, edge.child.step.id))
  );
}

/**
 * Occasionally, when the analysis is updated in the middle of the `GetAnalysis` GraphQL response being
 * generated, the GraphQL response may be internally inconsistent.
 *
 * Currently, Benchling's GraphQL endpoint does not guarantee internal consistency; to do so, it would have
 * to use (or expose an option for) REPEATABLE READ consistency.
 *
 * In particular, `GetAnalysisPipelineStep.definition.outgoingEdges` may reference steps that do not exist in
 * `AnalysisGraphQL.execution.steps`.
 *
 * To mitigate user impact while we investigate the underlying cause of these inconsistencies, we can
 * detect these inconsistencies on the front-end.
 */
export default function isAnalysisGraphQLInternallyConsistent(analysis: AnalysisGraphQL): boolean {
  const isConsistent = analysis.execution.steps.every((step) =>
    isAnalysisStepGraphQLInternallyConsistent(analysis, step)
  );
  return isConsistent;
}
